import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons";
import { faExclamationCircle, faExclamationTriangle, faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Divider, Icon, Row, Typography } from 'antd';
import React from 'react';
import { ColorConfigs } from "../../configurations";
import * as Assets from './../../assets';
/* ============================= */
/* NOTE : inside widget card -> "position:relative" to cover just the assigned portion of widget
                     outside -> "position:absolute" to cover full screen, handled by css */
/* ============================= */
export var WidgetWrapper = function (_a) {
    var suffix = _a.suffix, iconSize = _a.iconSize, iconType = _a.iconType, type = _a.type, title = _a.title, altTitle = _a.altTitle, altSubTitle = _a.altSubTitle, altSuffix = _a.altSuffix, subtitle = _a.subtitle, component = _a.component, image = _a.image;
    var imageConfig = {
        'bar': React.createElement(Assets.Views.Bar, null),
        'dot-line': React.createElement(Assets.Views.DotLine, null),
        'man-women': React.createElement(Assets.Views.ManWoman, null),
        'blue-bar': React.createElement(Assets.Views.BlueBar, null),
        'gray-bar': React.createElement(Assets.Views.GrayBar, null),
        'gray-dot-line': React.createElement(Assets.Views.DotLineGray, null)
    };
    var colorConfig = {
        'info': React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { size: iconSize || '3x', color: ColorConfigs.blue, icon: faInfoCircle }); } }),
        'error': React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { size: iconSize || '3x', color: ColorConfigs.pink, icon: iconType === 'triangle' ? faExclamationTriangle : faExclamationCircle }); } }),
        'load': React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { size: iconSize || '3x', color: ColorConfigs.blue, spin: true, icon: faSpinnerThird }); } }),
        'warn': React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { size: iconSize || '3x', color: ColorConfigs.yellow, icon: iconType === 'triangle' ? faExclamationTriangle : faExclamationCircle }); } }),
    };
    var centerVertical = React.createElement("div", { className: "widget-middle-wrapper" }, component ? component : (React.createElement(React.Fragment, null,
        colorConfig[type] && React.createElement("div", { className: "widget-icon-component" },
            " ",
            colorConfig[type],
            " "),
        title && React.createElement("div", { className: "widget-text-section" },
            React.createElement("span", { className: "widget-text-component" },
                React.createElement("span", { className: 'color-gray-6 widget-text-title' },
                    "  ",
                    title,
                    " "),
                subtitle && React.createElement("span", { className: 'color-gray-5 widget-text-subtitle' },
                    " ",
                    subtitle,
                    " "))),
        suffix && React.createElement("div", { className: "widget-suffix-component" },
            " ",
            suffix,
            " "))));
    var comp = centerVertical;
    if (type === "info" || type === 'error' || type === 'warn') {
        comp = React.createElement("div", { className: "info-container" }, centerVertical);
    }
    return (React.createElement("div", { className: 'main-widget-relative-wrapper' }, !altTitle ? React.createElement(Row, { type: 'flex', className: "main-widget-wrapper", justify: "center", align: "middle" },
        React.createElement(Col, { span: 24, className: "main-widget-box" }, comp),
        image && React.createElement(Col, { span: 24, className: "main-widget-box" }, imageConfig[image]))
        :
            React.createElement(Row, { type: 'flex', style: { flexDirection: "column" }, className: "main-widget-wrapper", justify: "center", align: "middle" },
                image && React.createElement(Col, { span: 24, className: "main-widget-box" }, imageConfig[image]),
                React.createElement(Col, { span: 24, className: "margin-top-lg" },
                    React.createElement(Typography.Title, { level: 1, className: "color-gray-5", style: { textAlign: "center" } }, altTitle)),
                altSubTitle && React.createElement(Col, { span: 20 },
                    React.createElement(Divider, { style: { height: 2, marginTop: 8, marginBottom: 18 } }),
                    React.createElement(Typography.Title, { level: 4, className: "color-gray-5", style: { textAlign: "center", fontWeight: "normal", fontSize: 14 } }, altSubTitle)),
                altSuffix && React.createElement(Col, { span: 24, className: "margin-top-sm", style: { display: "flex", justifyContent: "center" } }, altSuffix))));
};
//# sourceMappingURL=widget-wrapper.js.map